<img src="img/step/anim-record-countdown-iPad.gif?v={{animationTimestamp}}" *ngIf="visible" class="countdown" />
